import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "square-3q-zH",
  "use": "square-3q-zH-usage",
  "viewBox": "0 0 38 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 30\" id=\"square-3q-zH\"><path d=\"M14.168 29.603L0 15.435l6.174-6.174 7.994 7.994L31.424 0l6.174 6.174z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol